import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  AccountService,
  IUser,
  IApiLocation,
} from '../services/account.service';
import { LocationService, ILocation } from '../services/location.service';
import { ChecklistService, IChecklist } from '../services/checklist.service';
import { DaysOfWeek } from '../shared/api';

@Component({
  templateUrl: './dashboard.html',
})
export class DashboardComponent implements OnInit {
  public checklists: IChecklist[];
  public newChecklist: any;
  public loc: IApiLocation;
  public DaysOfWeek = DaysOfWeek;
  public DaysOfWeekKeys = Object.keys(DaysOfWeek).filter(e => {
    return e.toString().length < 3;
  });

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected checklistService: ChecklistService,
    protected locationService: LocationService,
    protected accountService: AccountService
  ) {}

  resetChecklist() {
    this.newChecklist = {
      days: [true, true, true, true, true, true, true],
    };
  }
  ngOnInit() {
    if (!this.accountService.getLocation()) {
      this.router.navigate(['/settings/account']);
      return;
    }
    this.checklistService.list().subscribe(data => {
      this.checklists = data;
    });
    this.loc = this.accountService.getLocation();
    this.resetChecklist();
  }

  saveChecklist(obj) {
    this.checklistService.update(obj._edit || obj).subscribe(data => {
      if (!obj.id) {
        obj.id = data.id;
        this.checklists.push(obj);
        this.resetChecklist();
      } else {
        delete obj._edit;
      }
    });
  }

  editObj(obj) {
    obj._edit = Object.assign({}, obj);
  }

  deleteChecklist(obj) {
    this.checklistService.delete(obj.id).subscribe(data => {
      let idx = this.checklists.indexOf(obj);
      this.checklists.splice(idx, 1);
    });
  }

  saveLocationField(fieldName) {
    let updateObj: any = {
      id: this.loc.id,
    };

    updateObj[fieldName] = (<any>this.loc)[fieldName];
    this.locationService.update(updateObj).subscribe(data => {});
    if (fieldName == 'has_inventory') {
      this.accountService.getLocation().has_inventory = updateObj[fieldName];
    }
    if (fieldName == 'week_start') {
      // So this one is special because of the menus.
      // Reset both of the date - menu trackers.
      this.accountService.notifyCurrentDateUpdate(0, null);
      this.accountService.notifyCurrentDateUpdate(1, null);
    }
  }
}
